<template>
  <div
    class="patient-create standard-layout"
    v-disable-all="$store.getters['user/hasReadOnlyAccess']"
  >
    <div class="d-flex justify-space-between flex-column flex-md-row">
      <h2 class="mb-4 standard-layout__heading">{{ $ucfirst($t('patient.create')) }}</h2>
      <patient-create-close-button></patient-create-close-button>
    </div>
    <patient-create-study-id ref="patientCreateStudyId"></patient-create-study-id>
    <div class="d-flex justify-space-between mb-8 mt-4">
      <div class="d-flex">
        <v-btn
          x-large
          color="primary"
          text
          @click="submit"
          class="mr-3"
        >
          {{ $ucfirst($t('general.submit', {catalog: 'app_mobile'})) }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import PatientCreateStudyId from './PatientCreateStudyId';
import PatientCreateCloseButton from './PatientCreateCloseButton.vue';

/**
 * Component PatientCreate.vue
 *
 * @module PatientCreate
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.2] app/src/APP_DASHBOARD/templates/views/Patient/Create/PatientCreate.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'EncounterInterface',
  components: {
    PatientCreateStudyId,
    PatientCreateCloseButton
  },
  methods: {
    async submit() {
      // validate study id field in child component
      const ref = this.$refs['patientCreateStudyId'];
      if (!ref.studyId) {
        ref.validate();
        return;
      }

      const patientId = await this.$store.dispatch('newPatient/create');

      if (patientId) {
        this.$router.push({
          name: 'PatientOverview',
          params: { patientId: patientId.toString() },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.patient-create__icon {
  height: 24px;
}

.patient-form__table {
  table > tbody > tr:hover {
    background-color: transparent !important;
  }

  td {
    font-size: 1rem !important;
    font-weight: 600;
    white-space: nowrap;
    padding-right: 32px;
  }

  td:not(:first-child) {
    width: 99%;
  }

  .v-text-field {
    margin-top: 28px;
    width: 220px;
  }

  .v-input--radio-group {
    margin-top: 24px;

    .v-messages {
      margin-bottom: 8px;
    }
  }
}

.patient-form__row {
  display: flex;
  align-content: center;
}

.patient-form__label {
  width: 180px;
  margin-right: 32px;
  font-weight: 600;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.patient-form__input {
  width: 220px;
  margin-right: 32px;
}

.patient-form__radio-group {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.patient-form__btn {
  font-size: 1rem !important;
}
</style>
